import { memo } from 'react';

/**
 * Feu d'artifice de fin de session — pur CSS, déterministe, one-shot (~6 s).
 * Chaque tir : une fusée lumineuse monte (0,5 s), puis explosion radiale de
 * 22 particules qui retombent en fondu (gravité simulée dans la keyframe).
 * Salve centrée sur le tiers haut de l'écran, puis c'est fini — pas de boucle.
 */
const TIRS = [
  // Vague 1 — double tir d'ouverture
  { x: 38, y: 26, couleur: '#FFB938', t: 0 },
  { x: 62, y: 22, couleur: '#4fc3f7', t: 0.12 },
  // Vague 2 — triple
  { x: 25, y: 30, couleur: '#f0663f', t: 0.9 },
  { x: 50, y: 16, couleur: '#8a5cf6', t: 1.0 },
  { x: 75, y: 28, couleur: '#22c55e', t: 1.12 },
  // Vague 3 — double
  { x: 33, y: 18, couleur: '#ec4899', t: 2.0 },
  { x: 68, y: 34, couleur: '#FFB938', t: 2.15 },
  // Bouquet final — quadruple
  { x: 20, y: 24, couleur: '#4fc3f7', t: 3.1 },
  { x: 44, y: 30, couleur: '#f0663f', t: 3.2 },
  { x: 58, y: 14, couleur: '#FFD54F', t: 3.3 },
  { x: 80, y: 26, couleur: '#8a5cf6', t: 3.42 },
];
const N_PARTICULES = 22;

const Tir = ({ x, y, couleur, t }) => {
  const particules = Array.from({ length: N_PARTICULES }, (_, k) => {
    const angle = ((k * (360 / N_PARTICULES) + k * 7) * Math.PI) / 180;
    const rayon = 85 + ((k * 29) % 70);
    return {
      dx: Math.cos(angle) * rayon,
      dy: Math.sin(angle) * rayon,
      taille: 6 + (k % 3) * 2,
    };
  });

  return (
    <>
      {/* Fusée */}
      <span
        className="proj-fw-fusee"
        style={{ left: `${x}%`, top: `${y}%`, background: couleur, boxShadow: `0 0 8px ${couleur}`, animationDelay: `${t}s` }}
      />
      {/* Explosion */}
      <span className="absolute" style={{ left: `${x}%`, top: `${y}%` }}>
        {particules.map((p, k) => (
          <span
            key={k}
            className="proj-fw-particule"
            style={{
              width: p.taille,
              height: p.taille,
              background: couleur,
              boxShadow: `0 0 10px ${couleur}, 0 0 20px ${couleur}55`,
              '--dx': `${p.dx.toFixed(1)}px`,
              '--dy': `${p.dy.toFixed(1)}px`,
              animationDelay: `${(t + 0.5).toFixed(2)}s`,
            }}
          />
        ))}
      </span>
    </>
  );
};

const FeuxArtifice = memo(function FeuxArtifice() {
  return (
    <div className="pointer-events-none fixed inset-0 overflow-hidden z-[5]" aria-hidden="true">
      {TIRS.map((tir, i) => <Tir key={i} {...tir} />)}
    </div>
  );
});

export default FeuxArtifice;
